import("./index.less").then(e => { })

import './mapa.js';

$(document).on('click', '.btn-show-valor', function () {
    let valor = Number($(this).data('valor'))
    console.log({ valor })
    valor = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(valor)
    console.log({ valor })
    $(this).html(`${valor}/m²`)
})